import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { translationManagerSlice } from "../features/translationManager/translatioManagerSlice";
import { instoreOrderTypeSlice } from "../features/instoreOrderTypes/instoreOrderTypesSlice";
import { instoreTemplateSlice } from "../features/instoreTemplates/instoreTemplatesSlice";
import { productVersionsSlice } from "../features/productVersions/productVersionsSlice";
import { instoreOrderSlice } from "../features/instoreOrders/instoreOrdersSlice";
import { instoreThemeSlice } from "../features/instoreThemes/instoreThemesSlice";
import { basketReasonSlice } from "../features/basketReason/basketReasonSlice";
import { instoreTypeSlice } from "../features/instoreTypes/instoreTypesSlice";
import { storeFormatSlice } from "../features/storeFormats/storeFormatSlice";
import { dashboardSlice } from "../features/dashBoard/dashboardSlice";
import { backOrderSlice } from "../features/backorder/backOrderSlice";
import { configureStore } from "@reduxjs/toolkit";
import { languageSlice } from "../features/languages/languageSlice";
import { productsSlice } from "../features/products/productsSlice";
import { countrySlice } from "../features/countries/countriesSlice";
import { accountSlice } from "../features/accounts/accountSlice";
import { ordersSlice } from "../features/orders/ordersSlice";
import { basketSlice } from "../features/basket/basketSlice";
import { storesSlice } from "../features/stores/storesSlice";
import { promoSlice } from "../features/promos/promosSlice";
import { usersSlice } from "../features/users/usersSlice";
import { digitalFrameSlice } from "../features/digitalFrames/digtalFramesSlice";

export const store = configureStore({
  reducer: {
    instoreOrders: instoreOrderSlice.reducer,
    instoreTemplates: instoreTemplateSlice.reducer,
    instoreThemes: instoreThemeSlice.reducer,
    instoreOrderTypes: instoreOrderTypeSlice.reducer,
    instoreTypes: instoreTypeSlice.reducer,
    digitalFramesManagement: digitalFrameSlice.reducer,
    translationManagement: translationManagerSlice.reducer,
    languagesManagement: languageSlice.reducer,
    countriesManagement: countrySlice.reducer,
    productVersions: productVersionsSlice.reducer,
    backOrderItems: backOrderSlice.reducer,
    basketReasons: basketReasonSlice.reducer,
    storeFormats: storeFormatSlice.reducer,
    dashboard: dashboardSlice.reducer,
    products: productsSlice.reducer,
    account: accountSlice.reducer,
    basket: basketSlice.reducer,
    stores: storesSlice.reducer,
    orders: ordersSlice.reducer,
    promos: promoSlice.reducer,
    users: usersSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

// GLOBAL REDUX TYPES
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// GLOBAL REDUX TYPED custom hooks
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
